import type { ModuleManifest } from '@eis/core';
import { claimsPermissions as p } from './permissions';
import { claimsResources } from './i18n';

/**
 * The claims module's single manifest — its one integration point with the shell (backbone §2).
 *
 * The console's view of claimservice (SDD-018 §9): the claims list, a read-only claim summary and
 * the create flow behind the coverage check (C-11). Full handling stays in the suite (C-12): the
 * detail hands over with "Im Schadenmodul öffnen". It owns the `claim-management` catalog and
 * nothing of the insurance module's — the policy tabs reach it through `links.claims.*` in
 * `@eis/core`.
 *
 * `nav` carries the SAME permission declaration the routes are guarded with (Addendum A.2).
 */
export const claimsModule: ModuleManifest = {
  id: 'claims',
  basePath: '/claims',
  routes: () => import('./routes'),
  nav: [
    {
      label: 'claims:nav.claims',
      icon: 'feather:alert-triangle',
      to: '/claims',
      section: 'claims:nav.sections.claims',
      permissions: [[p.claims.view]],
    },
  ],
  i18nNamespaces: ['claims'],
  permissionCatalog: p,
  featureFlagPrefix: 'claims.',
  i18nResources: claimsResources,
};
